import { OPTIMIZELY_FEATURE_FLAGS_KEYS, PARTNER_DASHBOARD_SMART_RATE } from 'components/Optimizely/Optimizely.features';
import { isFeatureEnabledForUser } from 'components/Optimizely/Optimizely.sdk';

export function isSmartRateFeatureEnabled(userId, venueId, countryCodeShort) {
  return isFeatureEnabledForUser(OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNER_DASHBOARD_SMART_RATE], userId, {
    active_venue_id: venueId,
    country_short_name: countryCodeShort,
  });
}
